import { createFileRoute } from '@tanstack/react-router';
import { CustomerPortalLogin } from '../pages/CustomerPortalLogin';
import { createOrgBasedLoader } from '../lib/portal-loaders';
import { Loader2 } from 'lucide-react';
import { z } from 'zod';

// Where to go after signing in (checked to be a page of this portal before it's used)
const portalLoginSearchSchema = z.object({
  redirect: z.string().optional().catch(undefined),
});

// Error fallback component for organization validation errors
function OrganizationError({ error }: { error: Error }) {
  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
          Organization Not Found
        </h1>
        <p className="text-gray-600 dark:text-gray-400 mb-6">
          {error.message || 'The organization you\'re looking for doesn\'t exist or has disabled their portal.'}
        </p>
        <button
          onClick={() => window.location.href = '/'}
          className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
        >
          Go Home
        </button>
      </div>
    </div>
  );
}

// Loading component
function PortalLoading() {
  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <Loader2 className="h-8 w-8 animate-spin mx-auto mb-4 text-blue-600" />
        <p className="text-gray-600 dark:text-gray-400">
          Validating organization...
        </p>
      </div>
    </div>
  );
}

function PortalLogin() {
  const loaderData = Route.useLoaderData();
  const { redirect } = Route.useSearch();

  return (
    <CustomerPortalLogin
      organizationInfo={loaderData.organizationInfo}
      redirect={redirect}
    />
  );
}

export const Route = createFileRoute('/org/$orgSlug/portal/login')({
  validateSearch: portalLoginSearchSchema,
  loader: createOrgBasedLoader(),
  component: PortalLogin,
  pendingComponent: PortalLoading,
  errorComponent: ({ error }) => <OrganizationError error={error} />,
});